import { useMediaQuery } from '@mui/material'

import { desktop, mobile } from './muiUtils'

/** breakpoints.down('md') */
export function useIsMobile() {
	return useMediaQuery((theme) => mobile({ theme }))
}

/** breakpoints.up('lg') */
export function useIsDesktop() {
	return useMediaQuery((theme) => desktop({ theme }))
}
